module.exports = __webpack_public_path__ + "img/lv.a51e2c97.svg";